import React, { useEffect, useState } from "react";




const Slide6 = (props) => {

    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 }); //parallax


    //parralax
    const updateMousePosition = (e) => {
        setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const parallaxStyle = {
        transition: 'transform 1s ease-out',
        transform: `translate(-${mousePosition.x / 150}px, -${mousePosition.y / 150}px)`
    };

    const parallaxStyle2 = {
        transition: 'transform 1s ease-out',
        transform: `translate(${mousePosition.x / 30}px, ${mousePosition.y / 30}px)`
    };

    const parallaxStyle3 = {
        transition: 'transform 1s ease-out',
        transform: `translate(${mousePosition.x / -40}px, ${mousePosition.y / -40}px)`
    };

    useEffect(() => {
        window.addEventListener('mousemove', updateMousePosition);

        return () => {
            window.removeEventListener('mousemove', updateMousePosition);
        };

    }, []);


    return (
        <div className="slide6Cont">
            <div className="slide6Cont__filtre1" style={parallaxStyle}></div>
            <div className="slide6Cont__filtre2" style={parallaxStyle2}></div>

            <div className="slide6Cont__content" style={parallaxStyle3}>
                <img alt="background coin" src="../../images/vitrine/slide6/coincoin.png" />

                <h2>rejoindre la FCU</h2>
                <p>Comme vous l'avez certainement remarqué, la Force Coloniale Unifiée est un projet ambitieux.
                    Nous souhaitons relever les plus grands défis que Star Citizen aura à nous offrir, découvrir le jeu dans ses moindres recoins,
                    exceller dans tous les aspects du jeu que nous abordons tout en maintenant un lien étroit avec le reste de la communauté et offrir à nos membres une expérience unique et immersive.
                    Mais quel profil de joueur recherchons-nous ?</p>

                <p>Eh bien, nous recherchons des joueurs qui veulent se surpasser et vivre de grandes aventures, tout simplement !</p>
                <p>Peu importe votre disponibilité. "IRL first".
                    Peu importe votre niveau ou vos connaissances du jeu au moment où vous postulez. Nous formons nos membres.
                    Peu importe si vous souhaitez tenir une arme ou une clé à molette... Tous les styles de gameplay seront accessibles au sein de la flotte.</p>
                <p>Si vous êtes prêt à relever des défis, que vous n'avez pas peur de prendre des coups,
                    Que vous souhaitez progresser dans vos styles de jeu préférés.</p>

                <a href='https://discord.gg/fcu' target='blank'> <div className="buttonEffect"></div><p>Nous rejoindre!</p> </a>
            </div>
        </div>
    );

};

export default Slide6;
